// @ts-check
import React from 'react';
import { Drawer, DrawerHeader } from 'preferral-ui/components/Drawer';
import { ImportRuleJSONForm } from './ImportRuleJSONForm';
import FlashMessageActions from 'shared/actions/FlashMessageActions';

/** @typedef {{
  isOpen: boolean;
  onClose(): void;
  onImport(rule: any): void;
}} ImportRuleJSONDrawerProps */

/** @type { React.FC<ImportRuleJSONDrawerProps> } */
export const ImportRuleJSONDrawer = (props) => {
  const { isOpen, onClose, onImport } = props;
  return (
    <Drawer isOpen={isOpen} onRequestClose={onClose} width="md">
      <DrawerHeader icon="copy" title="Import Rule" onClose={onClose} />

      <div className="p-4">
        <ImportRuleJSONForm
          onSave={(rule) => {
            onImport(rule);
            FlashMessageActions.flashSuccess({
              message: 'Rule imported!',
            });
            onClose();
          }}
        />
      </div>
    </Drawer>
  );
};
